module.exports = __webpack_public_path__ + "static/media/ipad.55c4a519.png";